"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Scheme_1 = require("react-sidenav/types/Scheme");

var constants_1 = require("../constants");

var getDefaultPathSeparator = function getDefaultPathSeparator(overridenPathSep) {
  if (overridenPathSep) {
    return overridenPathSep;
  }

  return constants_1.PATH_SEPARATOR;
};

exports.createNavItemProp = function (props, theme, template, selectedPath, pathSeparator, parentPathId, scheme) {
  if (scheme === void 0) {
    scheme = Scheme_1.Scheme.default;
  }

  var pathArr = parentPathId ? parentPathId.split(getDefaultPathSeparator(pathSeparator)) : [];
  var pathId = parentPathId ? "" + parentPathId + pathSeparator + props.id : "" + props.id;
  return {
    navProp: props,
    pathId: pathId,
    level: pathArr.length,
    theme: theme,
    template: template,
    scheme: scheme,
    selected: pathId === selectedPath,
    expanded: undefined,
    isLeaf: true
  };
};